import { createFileRoute, Outlet } from "@tanstack/react-router";
import PublicBaseLayout from "./_public/-components/PublicBaseLayout";
export const Route = createFileRoute("/_public")({
	component: RouteComponent,
});

function RouteComponent() {
	return (
		<PublicBaseLayout>
			<Outlet />
		</PublicBaseLayout>
	);
}
